import React from 'react';

import { Container } from './styles';

const Label: React.FC = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};

export default Label;
